import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { toPng } from "html-to-image";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Utility function to convert element to PNG
export const elementToPng = async (element) => {
  if (!element) return null;
  try {
    return await toPng(element, {
      quality: 1.0,
      pixelRatio: 2,
      skipAutoScale: true,
    });
  } catch (error) {
    console.error("Error converting element to PNG:", error);
    return null;
  }
};
